import { useCartStore } from '@/store'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import { toast } from 'react-toastify'

export type TProductSelected = {
  product:
    | IVariantsProduct
    | {
        product: Product | null
      }
    | undefined
  options: Record<string, string> | null
  parent: Product | null
}

type TAddToCartParams = {
  productSelected: TProductSelected[]
  quantity: number
  callbackOnSuccess?: () => void
  isBuyNow?: boolean
}
export const useAddToCart = () => {
  const { addToCart, isLoading, setShowCartMini, setIsAutoCloseMiniCart } = useCartStore()
  const t = useTranslations('Product')
  const router = useRouter()
  const handleAddToCart = async ({
    productSelected,
    quantity,
    callbackOnSuccess,
    isBuyNow,
  }: TAddToCartParams) => {
    const isEmpty = require('lodash/isEmpty')
    const omitBy = require('lodash/omitBy')
    try {
      const item = productSelected?.map((product) => {
        const isSimpleProduct = product?.product?.product?.__typename === 'SimpleProduct'
        const isOutOfStock = product?.product?.product?.stock_status == 'OUT_OF_STOCK'
        if (isOutOfStock) {
          throw new Error(t('detail.out-of-stock-tag'))
        }
        const cartItem: ICartItem = {
          sku: isSimpleProduct ? product?.parent?.sku || '' : product?.product?.product?.sku || '',
          quantity: quantity,
        }
        const validOptions = omitBy(product?.options, isEmpty)
        if (!isEmpty(validOptions)) {
          cartItem.selected_options = Object.values(validOptions) as string[]
        }

        return cartItem
      })

      await addToCart(item, false).then(() => {
        if (isBuyNow) {
          router.push('/cart')
        } else {
          setShowCartMini(true)
          setIsAutoCloseMiniCart(true)
        }
        callbackOnSuccess && callbackOnSuccess()
      })
    } catch (err: any) {
      console.error('Error adding to cart:', err)
      toast.error(err?.message || t('error-added-item'), {
        autoClose: 3000,
        closeButton: true,
      })
    }
  }
  return { handleAddToCart, isLoading }
}
